var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "event", attrs: { column: "" } },
    [
      _c(
        "chat-user-header",
        {
          attrs: {
            "main-icon": "history",
            event: _vm._.head(_vm.event.items),
            participants: _vm.participants
          }
        },
        [_vm._v("\n    updated the load\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.event.items, function(event, idx) {
        return _c(
          "v-flex",
          {
            key:
              "timeline-event-" +
              event.modifiedByUserId +
              "-" +
              event.timestamp +
              "-" +
              idx,
            staticClass: "text-xs-left event-line ml-1",
            attrs: { xs12: "", sm12: "", "align-center": "" }
          },
          [
            _c("span", { staticClass: "pl-4 font-weight-light" }, [
              _vm._v(_vm._s(event.attributeName) + "\n        "),
              _vm.oldValue(event)
                ? _c("span", [
                    _vm._v("changed from " + _vm._s(_vm.oldValue(event)))
                  ])
                : _c("span", [_vm._v("set")]),
              _vm._v("\n        to " + _vm._s(_vm.theValue(event)) + "\n    ")
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.showTime
        ? _c(
            "v-flex",
            {
              staticClass:
                "text-sm-right text-sm-left event-line font-weight-light caption pr-2",
              attrs: { xs12: "", sm2: "" }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatDate")(_vm.event.timestamp)))
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77f5d83b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f5d83b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/ChangeLogEventGroup.vue
// module id = null
// module chunks = 